import React, { useCallback } from 'react';
import { TypedMemo } from '../../common/types';
import { useEditorContext } from './SMLEditorContext';
import { SMLBlockPicker } from './picker/SMLBlockPicker';
import { SMLUndoToast } from './blocks/SMLUndoToast';
import { SMLConfirmCatalogDelete } from './blocks/SMLConfirmCatalogDelete';
import { useRequestDelete } from './blocks/useRequestDelete';

interface SMLEditorOverlaysProps {
  removal: ReturnType<typeof useRequestDelete>;
  notice: string | null;
  onCloseNotice: (notice: null) => void;
}

/** What sits over the editor: the block picker (`?add=1`), the Undo toast, a notice, the delete question. */
const SMLEditorOverlaysComponent: React.FC<SMLEditorOverlaysProps> = ({ removal, notice, onCloseNotice }) => {
  const { url, accountId } = useEditorContext();
  const { deletes, confirmFor, confirm, cancel } = removal;
  const closeNotice = useCallback(() => onCloseNotice(null), [onCloseNotice]);

  return (
    <>
      {url.isPickerOpen && <SMLBlockPicker />}
      {deletes.pending !== null && (
        <SMLUndoToast message={deletes.pending.message} onUndo={deletes.undo} onClose={deletes.flush} />
      )}
      {deletes.pending === null && notice !== null && <SMLUndoToast message={notice} onClose={closeNotice} />}
      {confirmFor !== null && (
        <SMLConfirmCatalogDelete accountId={accountId} widget={confirmFor} onConfirm={confirm} onCancel={cancel} />
      )}
    </>
  );
};

export const SMLEditorOverlays = TypedMemo(SMLEditorOverlaysComponent);
